import { IoIosHome, IoIosMail } from "react-icons/io"
import React from "react"
import Row from "react-bootstrap/Row"

export default function CardAlumni({ alumni }) {
  return (

      <div style={{flexDirection: "row", flexWrap: "wrap"}}>
        <l className="citationTitle">{alumni.Name} {"  "}</l>
        • {" "}
        {alumni.Email && (
          <>
          <a
              target="_blank"
              rel="noopener noreferrer"
              href={"mailto:" + alumni.Email}
              className="iconLink"
            >
            <IoIosMail/>
          </a>
            • {" "} </>

        )}

        <b className="citationAuthors">{alumni.Description}</b>
        {"  "} • {"  "}

        {alumni.Url && (
          <>
          <a
                target="_blank"
                rel="noopener noreferrer"
                href={alumni.Url}
                className="iconLink"
              >
                <IoIosHome/>
              </a>
              • {"  "} </>

        )
        }
        </div>
  )


}